export async function fetchProjectCategories(locale: string) {
  const res = await
fetch(`https://cms.interactiagency.com/wp-json/wp/v2/project_category?lang=${locale}`);
  if (!res.ok) throw new Error('Failed to fetch categories');
  const data = await res.json();
  // Si la réponse est un objet unique, transforme-le en tableau
  const categories = Array.isArray(data) ? data : [data];
  return categories.map((cat: any) => ({
    id: cat.id,
    name: cat.name,
  }));
}
